// bootstrap
import Form from 'react-bootstrap/Form';
// others
import Select from 'react-select'

import { queryTenementWFS, getTenementTypeList, getDefaultTenementTypeList, lookupSingleTenementId } from './TenementOverlay'
import { CustomDatePicker, formatDate } from '../CustomDateTools';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Tabs from 'react-bootstrap/esm/Tabs';
import Tab from 'react-bootstrap/Tab';
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import classNames from 'classnames'

import { useState, useEffect } from "react"
import { useMap } from '@vis.gl/react-maplibre';
import {
    FilterSection, FilterGroup, Chip, ChipRow, ChipMultiSelect, filterStyles,
} from '../filters/FilterControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
}))

export function TenementQueryTool({
    tenementFilters,
    setTenementFilters,
    setTenementPopup,
    setShowTenementPopup,
    overlayVisibility,
    setOverlayVisisbility,
    goldfindermap,
    trigger40EWizard }) {

    const [expiringInMulti, setExpiringInMulti] = useState(3);


    const tenementTypes = getTenementTypeList();

    const toggleIncludePendingTenements = () => {
        setTenementFilters({ ...tenementFilters, includePending: !tenementFilters.includePending });
    }

    const toggleIncludeLiveTenements = () => {
        setTenementFilters({ ...tenementFilters, includeLive: !tenementFilters.includeLive });
    }

    const toggleIncludeDeadTenements = () => {
        setTenementFilters({ ...tenementFilters, includeDead: !tenementFilters.includeDead });
    }

    const toggleIncludeSurveyedTenements = () => {
        setTenementFilters({ ...tenementFilters, includeSurveyed: !tenementFilters.includeSurveyed });
    }

    const toggleIncludeUnsurveyedTenements = () => {
        setTenementFilters({ ...tenementFilters, includeUnsurveyed: !tenementFilters.includeUnsurveyed });

    }

    const toggleTenementLabels = () => {
        setOverlayVisisbility({ ...overlayVisibility, tenementLabels: !overlayVisibility.tenementLabels });
    }

    const setSelectedTenementType = (typesIn) => {
        setTenementFilters({ ...tenementFilters, types: typesIn })
    }

    const setGrantDateBeforeAfter = (radioIn) => {
        setTenementFilters({ ...tenementFilters, grantDateBeforeAfter: radioIn.target.id });
    }

    const setTenementStartDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, startDate: dateIn });
    }

    const setTenementEndDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, endDate: dateIn });
    };

    const setTenementGrantDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, grantDate: dateIn });
    };

    const toggleOverridePendingTenementDisplay = () => {
        setTenementFilters({ ...tenementFilters, overridePendingTenementDisplay: !tenementFilters.overridePendingTenementDisplay });
    }

    const toggleIgnoreFirstTermPl = () => {
        setTenementFilters({ ...tenementFilters, ignoreFirstTermPl: !tenementFilters.ignoreFirstTermPl });
    }

    const toggleExpiringSoonEnabled = () => {
        if (tenementFilters.expiringSoonEnabled) {
            setTenementFilters({ ...tenementFilters, endDate: new Date(3001, 0, 1), expiringSoonEnabled: false });
        } else {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() + expiringInMulti)
            setTenementFilters({ ...tenementFilters, endDate: currentDate, expiringSoonEnabled: true });

        }

    }

    const setHolderNameLike = (input) => {
        setTenementFilters({ ...tenementFilters, holderNameLike: input });

    }

    const toggleDeadSpls = () => {

        setTenementFilters({
            ...tenementFilters,
            deadSpls: !tenementFilters.deadSpls,
            includeSurveyed: true,
            includeUnsurveyed: true
        });


    };

    const toggleGrantedOnly = () => {
        setTenementFilters({ ...tenementFilters, grantedOnly: !tenementFilters.grantedOnly });
    };

    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({ ...base, maxHeight: 200, overflowY: "auto" })
    };

    // Status and survey state are the two filters people touch constantly, so
    // they become chips you can read at a glance instead of six checkboxes in
    // two columns. The filter object keeps its boolean shape.
    const STATUS_CHIPS = [
        { key: 'includeLive', label: 'Live', toggle: toggleIncludeLiveTenements },
        { key: 'includePending', label: 'Pending', toggle: toggleIncludePendingTenements },
        { key: 'includeDead', label: 'Dead', toggle: toggleIncludeDeadTenements },
    ];
    const SURVEY_CHIPS = [
        { key: 'includeSurveyed', label: 'Surveyed', toggle: toggleIncludeSurveyedTenements },
        { key: 'includeUnsurveyed', label: 'Un-surveyed', toggle: toggleIncludeUnsurveyedTenements },
    ];

    // Tenement type is a {value,label} list in the filter object; the chips work
    // in plain strings, so convert at this edge.
    const typeValues = (tenementFilters.types || []).map((t) => t.value);
    const setTypeValues = (vals) =>
        setSelectedTenementType(
            vals.map((v) => tenementTypes.find((t) => t.value === v) || { value: v, label: v })
        );

    const EXPIRY_MONTHS = [1, 2, 3, 6, 12];

    // 55 tenement types, of which about a dozen matter to anyone looking for
    // gold in WA - the rest are POULTRY FARM, GARDEN AREA, COCOS (KEELING)
    // ISLAND EXPLORATION LICENCE and other historical curiosities. Showing all
    // 55 as chips was a wall you had to scroll past; showing the default set
    // and putting the remainder behind one toggle keeps the common case to a
    // few rows without hiding anything.
    const COMMON_TYPES = getDefaultTenementTypeList().map((t) => t.value);
    const [showAllTypes, setShowAllTypes] = useState(false);

    // "EXPLORATION LICENCE OFFSHORE" in a 336px column wraps to three lines and
    // makes every chip a different height. The type value is what gets filtered
    // on; this only shortens what is drawn.
    const shortTypeLabel = (v) => v
        .replace(/\bLICENCE\b/g, 'LIC')
        .replace(/\bLICENSE\b/g, 'LIC')
        .replace(/\bGENERAL PURPOSE\b/g, 'GEN PURPOSE')
        .replace(/\bMISCELLANEOUS\b/g, 'MISC')
        .replace(/\bCHRISTMAS ISLAND\b/g, 'XMAS IS.')
        .replace(/\bCOCOS \(KEELING\) ISLAND\b/g, 'COCOS IS.')
        .replace(/\bCOMMONWEALTH\b/g, 'CWLTH')
        .replace(/ S\.A\.$/, ' SA');

    // Uncommon types that were already selected when the panel opened stay on
    // screen for the life of the panel. Deriving the list from live typeValues
    // instead made a chip remove ITSELF the moment you deselected it - you had
    // to go back through "Show all 55" to undo a single click.
    const [pinnedTypes, setPinnedTypes] = useState(
        () => typeValues.filter((v) => !COMMON_TYPES.includes(v))
    );
    useEffect(() => {
        setPinnedTypes((prev) => {
            const extra = typeValues.filter((v) => !COMMON_TYPES.includes(v) && !prev.includes(v));
            return extra.length ? [...prev, ...extra] : prev;
        });
        // COMMON_TYPES is rebuilt every render; typeValues is the real trigger.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeValues.join('|')]);

    const visibleTypes = (showAllTypes
        ? tenementTypes
        : tenementTypes.filter((t) => COMMON_TYPES.includes(t.value) || pinnedTypes.includes(t.value))
    ).map((t) => ({ value: t.value, label: shortTypeLabel(t.label) }));

    function TransformTenId(input) {
        // sample -> M 15/1407, M15/1407
        let TenIdWithSpaceRegex = /[A-Za-z]\s[0-9]+\/[0-9]+/i;
        let TenIdWithNoSpaceRegex = /[A-Za-z][0-9]+\/[0-9]+/i;
        if (TenIdWithSpaceRegex.test(input)) {
            // then we just need to ensure that the first char is upper
            return input.charAt(0).toUpperCase() + input.slice(1);
        } else if (TenIdWithNoSpaceRegex.test(input)) {
            // then we need to add in the space after the first char
            const out = input.charAt(0).toUpperCase() + " " + input.substr(1, input.length);
            return out;
        } else {
            return input
        }
    }


    const LookupTenId = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        lookupSingleTenementId(TransformTenId(data.tenid), setTenementPopup, goldfindermap, setShowTenementPopup, trigger40EWizard);
    };

    const [tenementUpdateDate, setTenementUpdateDate] = useState(new Date());

    const DisplayTenementsLastUpdated = () => {
        GoldFinderApi.get("/tenements/last-update").then((result) => {

            setTenementUpdateDate(new Date(Date.parse(result.data[0].import_date_time)));
        }
        );

    }

    const getBtnClasses = (localMonths, targetMonths) => {
        return classNames(
            "btn",
            "btn-outline-primary",
            "btn-sm",
            { 'active': localMonths === targetMonths }

        )
    }

    useEffect(() => {
        DisplayTenementsLastUpdated();
    }, []);

    useEffect(() => {
        if (expiringInMulti !== "Other" && tenementFilters.expiringSoonEnabled) {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() + expiringInMulti)
            if (tenementFilters.endDate.getYear() !== currentDate.getYear() ||
                tenementFilters.endDate.getMonth() !== currentDate.getMonth() ||
                tenementFilters.endDate.getDay() !== currentDate.getDay()) {
                setTenementEndDate(currentDate);
            }
        }
    }, [expiringInMulti]);

    function DelayedStringInputField({ setValue, value }) {
        const [query, setQuery] = useState(value);

        useEffect(() => {
            if (query !== value) {

                const timeOutId = setTimeout(() => setValue(query), 1000);
                return () => clearTimeout(timeOutId);
            }
        }, [query]);


        useEffect(() => {
            if (query !== value) {
                setQuery(value);
            }
        }, [value]);

        return (
            <input
                type="text"
                value={query}
                placeholder="Holder name or key word"
                onChange={event => setQuery(event.target.value)}
                style={filterStyles.stepInput}
            />
        );
    }

    return (
        // One panel, no Simple/Advanced/Expiring tabs. The tabs split filters
        // that are used together - you pick a status and a type and an expiry
        // window in the same breath - and buried "Expiring soon" behind a tab
        // most people never opened.
        <div style={{ padding: '0 2px 8px' }}>
            {/* Tenement ID lookup moved to the global search box, which finds
                the same tenements plus holders, samples, sites and places. */}
            <FilterSection first label="Status" meta={`Updated ${formatDate(tenementUpdateDate)}`}>
                <ChipRow>
                    {STATUS_CHIPS.map((c) => (
                        <Chip key={c.key} selected={!!tenementFilters[c.key]} onClick={c.toggle}>
                            {c.label}
                        </Chip>
                    ))}
                </ChipRow>
                <ChipRow>
                    {SURVEY_CHIPS.map((c) => (
                        <Chip key={c.key} selected={!!tenementFilters[c.key]} onClick={c.toggle}>
                            {c.label}
                        </Chip>
                    ))}
                </ChipRow>
                <ChipRow>
                    <Chip selected={!!tenementFilters.grantedOnly} onClick={toggleGrantedOnly}>
                        Granted only
                    </Chip>
                    <Chip
                        selected={!!tenementFilters.deadSpls}
                        onClick={toggleDeadSpls}
                        title="Dead special prospecting licences - ground that has been pegged before"
                    >
                        Dead SPLs
                    </Chip>
                </ChipRow>
            </FilterSection>

            {/* Everything below is grouped and collapsed by default. One flat
                panel put every tenement control on a single scroll, which made
                the sidebar long enough that filtering was impractical. Groups
                keep it all one scroll with nothing behind a tab, but only what
                you reach for constantly is open - and each collapsed header
                still reports its state, so you rarely need to open one to see
                what it is doing. */}
            <FilterGroup label="Tenement type" summary={`${typeValues.length} of ${tenementTypes.length}`}>
                <ChipMultiSelect
                    meta={null}
                    options={visibleTypes}
                    selected={typeValues}
                    onChange={setTypeValues}
                />
                <FilterSection>
                    <ChipRow>
                        <Chip onClick={() => setShowAllTypes(!showAllTypes)}>
                            {showAllTypes ? 'Show common only' : `Show all ${tenementTypes.length}`}
                        </Chip>
                        <Chip onClick={() => setTypeValues(COMMON_TYPES)}>Reset</Chip>
                        <Chip onClick={() => setTypeValues([])}>Clear</Chip>
                    </ChipRow>
                </FilterSection>

            </FilterGroup>

            {/* Kept, even though the global search box also matches holder
                names - the two do different jobs. Search FINDS one of a
                holder's tenements and flies to it; this FILTERS the layer, so
                only their ground draws as you pan around looking at it. The
                label says "Only show" to make that difference visible rather
                than leaving it as a second search field. */}
            <FilterGroup
                label="Holder"
                summary={tenementFilters.holderNameLike ? tenementFilters.holderNameLike : 'Any'}
            >
                <FilterSection>
                    <div style={{ ...filterStyles.label, marginBottom: 7 }}>Only show ground held by</div>
                    <div style={{ ...filterStyles.stepbox, marginTop: 0 }}>
                        <DelayedStringInputField
                            value={tenementFilters.holderNameLike}
                            setValue={(val) => setHolderNameLike(val)}
                        />
                    </div>
                    {tenementFilters.holderNameLike ? (
                        <ChipRow>
                            <Chip onClick={() => setHolderNameLike('')}>Clear</Chip>
                        </ChipRow>
                    ) : null}
                </FilterSection>

            </FilterGroup>

            <FilterGroup label="Expiring soon" summary={tenementFilters.expiringSoonEnabled
                ? (expiringInMulti === 'Other' ? formatDate(tenementFilters.endDate) : `${expiringInMulti} months`)
                : 'Off'}>
                {/* One switch, stated as what it does. It used to be an On/Off
                    text action in the section head, which read as a label rather
                    than a control and duplicated the state the group header was
                    already reporting. */}
                <FilterSection>
                    <ChipRow>
                        <Chip
                            selected={!!tenementFilters.expiringSoonEnabled}
                            onClick={() => toggleExpiringSoonEnabled()}
                            title="Show only tenements whose end date falls inside the window below"
                        >
                            Only show expiring ground
                        </Chip>
                    </ChipRow>

                    {tenementFilters.expiringSoonEnabled && (
                        <>
                            <div style={{ ...filterStyles.label, marginTop: 14 }}>Expiring within</div>
                            <ChipRow>
                                {EXPIRY_MONTHS.map((m) => (
                                    <Chip key={m} mono selected={expiringInMulti === m}
                                          onClick={() => setExpiringInMulti(m)} title={`${m} months`}>
                                        {m} mo
                                    </Chip>
                                ))}
                                <Chip selected={expiringInMulti === 'Other'} onClick={() => setExpiringInMulti('Other')}>
                                    Pick a date
                                </Chip>
                            </ChipRow>
                            {expiringInMulti === 'Other' && (
                                <div style={{ marginTop: 9 }}>
                                    <CustomDatePicker
                                        date={tenementFilters.endDate}
                                        setDate={(d) => setTenementEndDate(d)}
                                    />
                                </div>
                            )}
                            <div style={{ ...filterStyles.label, marginTop: 14 }}>Also</div>
                            <ChipRow>
                                <Chip
                                    selected={!!tenementFilters.overridePendingTenementDisplay}
                                    onClick={toggleOverridePendingTenementDisplay}
                                    title="Also show pending tenements that overlap the expiring ground"
                                >
                                    Show overlapping pending
                                </Chip>
                                <Chip
                                    selected={!!tenementFilters.ignoreFirstTermPl}
                                    onClick={toggleIgnoreFirstTermPl}
                                    title="Prospecting licences in their first term rarely come up for grabs"
                                >
                                    Ignore first-term PLs
                                </Chip>
                            </ChipRow>
                        </>
                    )}
                </FilterSection>

            </FilterGroup>

            <FilterGroup label="Dates">
                <FilterSection>
                    <div style={{ marginTop: 9, display: 'grid', gap: 8 }}>
                        <div>
                            <span style={filterStyles.meta}>Started after</span>
                            <CustomDatePicker
                                date={tenementFilters.startDate}
                                setDate={(d) => setTenementStartDate(d)}
                            />
                        </div>
                        <div>
                            <span style={filterStyles.meta}>Ends before</span>
                            <CustomDatePicker
                                date={tenementFilters.endDate}
                                setDate={(d) => setTenementEndDate(d)}
                            />
                        </div>
                        <div>
                            <span style={filterStyles.meta}>Granted</span>
                            <ChipRow>
                                <Chip
                                    selected={tenementFilters.grantDateBeforeAfter === 'BEFORE'}
                                    onClick={() => setGrantDateBeforeAfter({ target: { id: 'BEFORE' } })}
                                >
                                    Before
                                </Chip>
                                <Chip
                                    selected={tenementFilters.grantDateBeforeAfter === 'AFTER'}
                                    onClick={() => setGrantDateBeforeAfter({ target: { id: 'AFTER' } })}
                                >
                                    After
                                </Chip>
                            </ChipRow>
                            <CustomDatePicker
                                date={tenementFilters.grantDate}
                                setDate={setTenementGrantDate}
                            />
                        </div>
                    </div>
                </FilterSection>

            </FilterGroup>

            <FilterGroup label="On the map" defaultOpen>
                <FilterSection>
                    <ChipRow>
                        <Chip selected={!!overlayVisibility.tenementLabels} onClick={toggleTenementLabels}>
                            Labels
                        </Chip>
                        <Chip
                            selected={!!overlayVisibility.section19}
                            onClick={() => setOverlayVisisbility({ ...overlayVisibility, section19: !overlayVisibility.section19 })}
                        >
                            Section 19
                        </Chip>
                        <Chip
                            selected={!!overlayVisibility.amalgamationsPending}
                            onClick={() => setOverlayVisisbility({ ...overlayVisibility, amalgamationsPending: !overlayVisibility.amalgamationsPending })}
                        >
                            Amalgamations pending
                        </Chip>
                    </ChipRow>
                </FilterSection>
            </FilterGroup>

        </div>
    )
}
